<template>
    <div>
        <SelectField
            v-model="modelValue.category"
            name="cookie_consent_service_category"
            label="category"
            help="help_cookie_consent_service_category"
            :required="true"
            :options="mapEnumToArray(CookieConsentServiceCategory)"
        />
        <SelectField
            v-model="modelValue.provider_key"
            name="cookie_consent_service_provider_key"
            label="provider_key"
            help="help_cookie_consent_service_provider_key"
            :required="true"
            :options="mapEnumToArray(CookieConsentServiceProviderKey)"
        />
        <ToggleSwitch
            v-model="modelValue.enabled"
            name="cookie_consent_service_enabled"
            label="enabled"
            help="help_cookie_consent_service_enabled"
        />
        <div class="my-4 flex h-10 w-full items-center justify-end">
            <CookieConsentServiceLangSwitch
                v-model:active-locale="activeLocale"
            />
        </div>
        <TextField
            v-model="modelValue.name[activeLocale]"
            name="cookie_consent_service_name"
            label="name"
            help="help_cookie_consent_service_name"
            :required="true"
        />
        <EditorField
            v-model="modelValue.description[activeLocale]"
            name="cookie_consent_service_description"
            label="description"
            help="help_cookie_consent_service_description"
        />
    </div>
</template>

<script setup lang="ts">
import { useEnum } from '@composables/common'
import {
    EditorField,
    SelectField,
    TextField,
    ToggleSwitch,
} from '@src/components'
import {
    CookieConsentServiceCategory,
    CookieConsentServiceProviderKey,
} from '@src/enums'
import {
    COOKIE_CONSENT_SERVICE_LOCALES,
    CookieConsentService,
    type CookieConsentServiceLocale,
} from '@src/types'
import { Ref, ref, toRefs, watch } from 'vue'
import CookieConsentServiceLangSwitch from './CookieConsentServiceLangSwitch.vue'

const props = defineProps<{
    modelValue: Ref<CookieConsentService>
}>()

const { modelValue } = toRefs(props)

const emit = defineEmits(['update:modelValue'])

const { mapEnumToArray } = useEnum()

const activeLocale = ref<CookieConsentServiceLocale>(
    COOKIE_CONSENT_SERVICE_LOCALES[0]
)

watch(modelValue, (value) => {
    emit('update:modelValue', value)
})
</script>

<style lang="scss" scoped></style>
